(function() {
    // 注册组件
    SR.component.extend('tts', tts);

    function tts() {
        if (SR.state.tts) {
            var playTag = 'playing';
            var stopTag = 'stop';
            var isPlaying = 'isplaying';
            var play = 'play';
            var timer, loading;

            SR.dom.$body.on('click.tts', '.J_read', function(e) {
                // console.log('read');
                var $me = $(this).find('.play-btn');
                var $audio = $me.find('.tts-audio');
                var content = $me.parents('.robot').find('.tts-content').text();
                var contentLen = content.length;
                var url = 'http://tsn.baidu.com/text2audio?tex=' + encodeURIComponent(content) + '&lan=zh&cuid=2dba576fb51c40c46a431b7d6f827291&ctp=1&per=2&tok=' + SR.data.bdat;
                if (contentLen > 1024) {
                    console.log('文本内容超长');
                    return;
                }
                //如果有音频正在播放，先暂停
                if ($('.tts-audio')) {
                    clearInterval(timer);
                    clearInterval(loading);
                    $('.tts-audio').not($me.find('.tts-audio')).each(function(i) {
                        $(this).parent().removeClass(playTag).removeClass(isPlaying).removeClass(play).removeClass(stopTag).removeAttr('style');
                        $(this).remove();
                    });
                }
                $audio.unbind();
                if ($audio.length) {
                    if ($me.hasClass(playTag)) {
                        clearInterval(timer);
                        $me.removeClass(playTag).removeClass(isPlaying).removeClass(play).addClass(stopTag);
                        $audio.get(0).pause();
                    } else {
                        $me.removeClass(stopTag).addClass(playTag);
                        $audio.get(0).play();
                    }
                } else {
                    $audio = $('<audio class="tts-audio"><source src="' + url + '" type="audio/mp3" /></audio>');
                    $me.append($audio).addClass(playTag);
                    $audio.get(0).play();
                }

                $audio.on('waiting', function() {
                    var i = 0,
                        n = 0;
                    // $me.css({
                    //     'background-size': '18px 108px',
                    //     'background-position': '0 -54px',
                    //     'pointer-events': 'none',
                    //     'margin-top': '11px'
                    // });
                    $me.addClass('waiting');
                    loading = setInterval(function() {
                        n++;
                        if (n > 20) {
                            $audio.remove();
                            // $me.removeAttr('style');
                            $me.removeClass('waiting');
                            clearInterval(loading);
                            return false;
                        }
                        if (i >= 3) {
                            i = 0;
                        }
                        // var y = -54 - i * 18;
                        // $me.css('background-position', '0 ' + y + 'px');
                        $me.removeClass('w-0 w-1 w-2').addClass('w-' + i);
                        i++;
                    }, 400);
                });

                $audio.on('playing', function() {
                    clearInterval(loading);
                    $me.removeClass('waiting').removeAttr('style').addClass(isPlaying);
                    timer = setInterval(function() {
                        if ($me.hasClass(isPlaying)) {
                            $me.removeClass(isPlaying).addClass(play);
                        } else {
                            $me.removeClass(play).addClass(isPlaying);
                        }
                    }, 400);
                });

                $audio.on('ended', function() {
                    clearInterval(timer);
                    $me.removeClass(play).removeClass(isPlaying).removeClass(playTag);
                });
            });
        }
    }
}());
